export const PACKAGE_NAME = '@jira/admin-pages__system-announcement-banner-resources' as const;
